// @flow
import XYZ from 'ol/source/XYZ'
import OSM from 'ol/source/OSM'
import Tile from 'ol/layer/Tile'
import * as imageSrc from '../../../er2_map_baselayers/images'
import * as actionTypes from '../constants/action_types'

export type MapBaseLayerType = {
    // Save copy of API keys from map state
    apiKeys: {},
    // Current base layer (value)
    baseLayer: string,
    baseLayerChoices: [{
        // Name to display in component and must be unique
        name: string,
        // Icon src
        imageSrc: string,
        // Return an OpenLayers Layer
        create: Function,
    }],
}

export type ActionType = {
    type: string,
    baseLayer?: string,
    state: {
        map: {
            baseLayer: string,
        },
    },
}

const makeUSGS = (layerName: string) => {
    const baseURL = 'https://basemap.nationalmap.gov/arcgis/rest/services/'
    const url = baseURL + layerName
    return new Tile({
        source: new XYZ({
            url: `${url}/MapServer/tile/{z}/{y}/{x}`,
            crossOrigin: 'anonymous',
        }),
    })
}

export const initialState = {
    apiKeys: {},
    baseLayer: null,
    baseLayerChoices: [
        {
            name: 'OpenStreetMap',
            imageSrc: imageSrc.osmIcon,
            create: () => new Tile({
                source: new OSM(),
            }),
        }, {
            name: 'USGS Imagery',
            imageSrc: imageSrc.usgsImagery,
            create: () => makeUSGS('USGSImageryOnly'),
        }, {
            name: 'USGS Imagery Topo',
            imageSrc: imageSrc.usgsTopo,
            create: () => makeUSGS('USGSImageryTopo'),
        }, {
            name: 'USGS Hydro-NHD',
            imageSrc: imageSrc.usgsHydro,
            create: () => makeUSGS('USGSHydroCached'),
        }, {
            name: 'USGS Shaded Relief',
            imageSrc: imageSrc.usgsShaded,
            create: () => makeUSGS('USGSShadedReliefOnly'),
        }, {
            name: 'None',
            imageSrc: imageSrc.noneIcon,
            create: () => null,
        },
    ],
}

function createBaseLayer(baseLayerChoice, apiKeys) {
    let layer
    if (baseLayerChoice) {
        layer = baseLayerChoice.create(apiKeys)
        if (layer) {
            layer.set('baseLayerName', baseLayerChoice.name)
        }
    }
    return layer
}

export default function mapBaseLayer(state: MapBaseLayerType = initialState, action: ActionType) {
    let newstate = state
    if (action.type === actionTypes.SET_FETCHED_STATE) {
        if (action.state.map) {
            const baseLayerChoice = state.baseLayerChoices.find(c => c.name === action.state.map.baseLayer) ||
                state.baseLayerChoices[0]
            newstate = {
                ...state,
                apiKeys: action.state.map.apiKeys,
                baseLayer: createBaseLayer(baseLayerChoice, action.state.map.apiKeys),
            }
        }
    } else if (action.type === actionTypes.CHANGE_BASELAYER) {
        const baseLayerChoice = state.baseLayerChoices.find(c => c.name === action.baseLayer)
        newstate = {
            ...state,
            baseLayer: createBaseLayer(baseLayerChoice, newstate.apiKeys),
        }
    }
    return newstate
}
